/**
 * Gate.io WebSocket API
 * @see https://www.gate.io/docs/developers/apiv4/ws/en/
 */

import type {
  GateDepthStreamResult,
  GateKlineStreamResult,
  GateTickerStreamResult,
  GateTradeStreamResult,
  GateWsEnvelope,
} from './types';

import type { WsChannelDescriptor, WsTopologyInfo } from '../../lib/types';

export const GATE_WS_BASE_URL = 'wss://ws.gate.io/v3/';

/**
 * @see https://www.gate.io/docs/developers/apiv4/ws/en/
 */
export const GATE_WS_CHANNELS: Record<string, WsChannelDescriptor> = {
  orderbook: {
    channel: 'orderbook',
    topic: 'spot.order_book',
    supportsBatching: true,
    docUrl: 'https://www.gate.io/docs/developers/apiv4/ws/en/#order-book-channel',
  },
  ticker: {
    channel: 'ticker',
    topic: 'spot.ticker',
    supportsBatching: true,
    docUrl: 'https://www.gate.io/docs/developers/apiv4/ws/en/#tickers-channel',
  },
  trades: {
    channel: 'trades',
    topic: 'spot.trades',
    supportsBatching: true,
    docUrl: 'https://www.gate.io/docs/developers/apiv4/ws/en/#trades-channel',
  },
  klines: {
    channel: 'klines',
    topic: 'spot.candlesticks',
    supportsBatching: true,
    docUrl: 'https://www.gate.io/docs/developers/apiv4/ws/en/#candlesticks-channel',
  },
};

export const GATE_WS_TOPOLOGY: WsTopologyInfo = {
  baseUrl: GATE_WS_BASE_URL,
  singleConnectionPerChannel: false,
  heartbeatIntervalMs: 30_000,
  note: 'JSON-RPC protocol; send manual ping frames `{ "ping": <timestamp> }` roughly every 30 seconds.',
};

export type {
  GateDepthStreamResult,
  GateKlineStreamResult,
  GateTickerStreamResult,
  GateTradeStreamResult,
  GateWsEnvelope,
};
